import React from 'react';
import { sanitizeHTML } from '@benzinga/frontend-utils';

const isSrcTagType = (src?: string) => {
  if (!src) return false;
  const tagMatch = src.match(/<\/?[a-z][\s\S]*>/i);
  return !!(tagMatch && tagMatch[0]);
};

export const ImpressionTag: React.FC<{ src?: string }> = ({ src }) => {
  if (!src) {
    return <div />;
  } else if (isSrcTagType(src)) {
    return <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(src) }}></div>;
  } else {
    return <script className="impression-tag" src={src} />;
  }
};

export default ImpressionTag;
